import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M5.765 4.076A.5.5 0 0 0 5 4.5v5a.5.5 0 0 0 .765.424l4-2.5a.5.5 0 0 0 0-.848z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const entertainmentControlButtonCirclePlay = { render };
export {
  entertainmentControlButtonCirclePlay as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-play.svg.js.map
